"use client";

import { API_ENDPOINT, QueryKeys } from "@cede/utils";
import { useApi } from "@/hooks/core/useApi";
import { useHubUser } from "@/hooks/user/useHubUser";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { enqueueSnackbar } from "notistack";

export function useStopBot() {
  const { auth } = useHubUser();
  const apiHelper = useApi();
  const queryClient = useQueryClient();

  const { mutate: stopBot, isPending } = useMutation({
    mutationFn: async (botId: number) => {
      return apiHelper.deleteAuth(auth, API_ENDPOINT.HUB_AIRDROP_FARMING_BOTS, {
        pathParams: [botId.toString()],
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.AIRDROP_FARMING_BOTS] });
      enqueueSnackbar("Bot stop requested", { variant: "success" });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Failed to stop bot: ${error.message}`, { variant: "error" });
    },
  });

  return { stopBot, isStopping: isPending };
}
